module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('building-number-field', {
    attrs: {
      "error": _vm.$attrs.errors.building.number
    },
    model: {
      value: (_vm.$attrs.building.number),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.building, "number", $$v)
      },
      expression: "$attrs.building.number"
    }
  }), _vm._v(" "), _c('contract-number-prefixes-field', {
    attrs: {
      "error": _vm.$attrs.errors.building.contract_number_prefixes
    },
    model: {
      value: (_vm.$attrs.building.contract_number_prefixes),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.building, "contract_number_prefixes", $$v)
      },
      expression: "$attrs.building.contract_number_prefixes"
    }
  }), _vm._v(" "), _c('address-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.formType == 'add' && _vm.$attrs.building.address)),
      expression: "!(formType == 'add' && $attrs.building.address)"
    }],
    attrs: {
      "error": _vm.$attrs.errors.building.address
    },
    model: {
      value: (_vm.$attrs.building.address),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.building, "address", $$v)
      },
      expression: "$attrs.building.address"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3fb6eaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/building/BuildingBlankForm.vue
// module id = 720
// module chunks = 0